import React, { useEffect } from 'react'
import { widgetUrl } from '../../../common/utils/constants'

const WebComponent = ({ ...props }) => {
  const src = widgetUrl
  const tagName = 'labra-bwa-cards'

  useEffect(() => {
    if (!document.querySelector(`script[src="${src}"]`)) {
      const script = document.createElement('script')
      script.src = src
      script.type = 'module'
      document.body.appendChild(script)
    }
  }, [])

  return React.createElement(tagName, props)
}

export default WebComponent
